// Tiny classnames helper. Skips falsy values, joins truthy ones with a space.
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
